import { useRoute } from "vue-router";
import { useUiStore } from "@/stores/ui";
import type { OpenCreatePostOptions } from "@/types";

/**
 * Returns the group context (name + avatar) to pre-fill the composer
 * based on the current route (group feed or groups list with a focused group).
 */
export function useCreatePostContext() {
  const route = useRoute();
  const uiStore = useUiStore();

  function getGroupContext(): OpenCreatePostOptions | undefined {
    if (route.name === "group-feed") {
      const g = uiStore.currentGroupFeed;
      if (g?.name) {
        return { groupName: g.name, groupAvatar: g.avatar };
      }
    }
    const focused = uiStore.groupsListFocusedGroup;
    if (route.name === "groups" && focused) {
      return { groupName: focused.name, groupAvatar: focused.avatar };
    }
    return undefined;
  }

  return { getGroupContext };
}
